import { css } from "lit-element";

export const StofwareColors = css`
	.bg-white {
		background-color: #fff;
	}
	.fill-white {
		fill: #ffffff;
	}
`;
